import { IS_FETCHING } from 'ACTIONS';

export const setIsFetching = (id, isFetching) => ({
    type: IS_FETCHING,
    id,
    isFetching
});
